import { Card, Grid } from "@mui/material";
import { newAdmission } from "api/routes";
import Loading from "components/Loading";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState } from "react";
import AdmissionPatientList from "./AdmissionPatientList";
import { toast } from "react-toastify";

export default function Admission() {
  const [loading, setLoading] = useState(false);
  const [refid, setRefid] = useState();
  const [nationalCode, setNationalCode] = useState();
  const [trigger, setTrigger] = useState(null);
  const submit = () => {
    if (refid && nationalCode) {
      setLoading(true);
      const data = {
        refid,
        nationalCode,
      };
      newAdmission(data, (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          setLoading(false);
          toast.success(`تایید صندوق ${data.firstName} ${data.lastName} انجام شد!`);
          setTrigger(Math.random());
          setNationalCode("")
          setRefid("")
        }
      });
    }
  };
  return (
    <DashboardLayout>
      <Loading loading={loading} />
      <MDBox pt={2} mb={6}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <MDTypography variant="h6" color="white">
                  تایید صندوق
                </MDTypography>
                <DashboardNavbar />
              </MDBox>
              <MDBox pt={6} px={2}>
                <Grid container spacing={6}>
                  <Grid item xs={4}>
                    <MDInput value={refid} onChange={(event) => setRefid(event.target.value)} type="text"
                             label="کدپیگیری" fullWidth />
                  </Grid>
                  <Grid item xs={4}>
                    <MDInput value={nationalCode} onChange={(event) => setNationalCode(event.target.value)} type="text"
                             label="کدملی" fullWidth />
                  </Grid>
                </Grid>

                <MDButton onClick={submit} variant="gradient" color="info" sx={{ width: "140px", margin: "2rem 0" }}>
                  تایید
                </MDButton>

              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <MDTypography variant="h6" color="white">
                  لیست تایید صندوق
                </MDTypography>
              </MDBox>
              <MDBox pt={6} px={2}>
                <AdmissionPatientList trigger={trigger} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

    </DashboardLayout>
  );
}
